import { AppStore } from "@/store/AppStore";
import { AssociatedModelKind, FeedbackKind } from "@/store/feedback/types";

export const searchFeedback = async ({
  store,
  feedbackKind,
  associatedModelKind,
  associatedModelIds,
}: {
  store: AppStore;
  feedbackKind: FeedbackKind;
  associatedModelKind: AssociatedModelKind;
  associatedModelIds: string[];
}) => {
  const feedbacks = await store.feedback.localTable
    .where("feedback_kind")
    .equals(feedbackKind)
    .and(
      feedback =>
        feedback.model_data.associated_model_kind === associatedModelKind &&
        !!feedback.model_data.associated_model_id &&
        associatedModelIds.includes(feedback.model_data.associated_model_id)
    )
    .toArray();

  return feedbacks;
};
